module.exports = __webpack_public_path__ + "img/24gf-phone24h.484cf1d3.png";